import { SPAN_SCOPE } from '../config/spanScope';
import { reportTraceScopeStatusGetter } from './reportTraceScopeStatusGetter';

export const METRIC_TRACE_SCOPE_SATUS_MAP = {
    [SPAN_SCOPE.REPORT_SCOPE]: reportTraceScopeStatusGetter,
};
